import React from "react";

import "./PresetItem.scss";

const PresetItem = ({ item, func }) => {
  return (
    <div className="preset-item" onClick={() => func(item)}>
      <div className="left-textbox">
        <p className="preset-item-name">{item.pluNm}</p>
        <p className="preset-item-price">{item.price}원</p>
      </div>
      <div className="preset-item-img">
        {item.imgNm.length ? (
          <img
            src={require(`../../images/items/${item.imgNm}`)}
            alt="preset-item-detail"
          />
        ) : (
          <img
            src={require("../../images/items/item-none.png")}
            alt="preset-item-detail"
          />
        )}
      </div>
    </div>
  );
};

export default PresetItem;
